export const TOAST_CONFIG = {
  position: 'bottom-center' as const,
  duration: 4000,
}

export const SKELETON_DELAY = {
  delay: 200,
  minDuration: 400,
}

export const DEFAULT_STALE_TIME = 5 * 60 * 1000 // 5 minutes — matches createQueryClientConfig default

export const CENSUS_TEMPLATE_PATH = '/samples/census-template.csv'
export const CENSUS_TEMPLATE_FILE_NAME = 'census-template.csv'

export * from './storage'
